import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TaxaJurosEquivalenteListagemComponent } from "./taxa-juros-equivalente/taxa-juros-equivalente-listagem.component";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { DominiosResolver } from "src/app/shared/resolvers/dominios.resolver";
import { TaxaJurosMaximaAgenteListagemComponent } from "./taxa-juros-maxima-agente/taxa-juros-maxima-agente-listagem.component";
import { TaxaJurosMediaAgentePesquisaComponent } from "./taxa-juros-media-agente/taxa-juros-media-agente-pesquisa.component";
import { AgenteFinanceiroResolver } from "src/app/shared/resolvers/agente-financeiro.resolver";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { JanelasApuracaoPesquisaComponent } from "./janelas-apuracao/janelas-apuracao-pesquisa.component";
import { JanelasApuracaoCadastroComponent } from "./janelas-apuracao/cadastro/janelas-apuracao-cadastro.component";
import { CanDeactivateGuardService } from "src/app/core/can-deactivate-guard.service";

const routes: Routes = [
  {
    path: 'taxa-juros-equivalente/listagem',
    component: TaxaJurosEquivalenteListagemComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      dominios: DominiosResolver
    },
    data: { canReuse: false }
  },
  {
    path: 'taxa-juros-maxima-agente/listagem',
    component: TaxaJurosMaximaAgenteListagemComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'taxa-juros-media-agente/pesquisa',
    component: TaxaJurosMediaAgentePesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver
    },
    data: { canReuse: false }
  },
  {
    path: 'janelas-apuracao/pesquisa',
    component: JanelasApuracaoPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'janelas-apuracao',
    component: JanelasApuracaoCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'janelas-apuracao/:id',
    component: JanelasApuracaoCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    canDeactivate: [CanDeactivateGuardService],
    data: { canReuse: false },
},
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class TaxasJurosRoutingModule{}